var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"checkout_redesign"}},[_c('div',{staticClass:"checkout_redesign--payment-cards_wrapper"},[_c('router-view'),_vm._v(" "),_c('Preloader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }